import { ref } from "vue";
import { authentication } from "@/lib/integrations/index";
import router, { routerIsReady } from "@/router";

export enum AuthStatus {
    // There is a brief period prior to the initialization of the
    // authentication where the AuthStatus is unknown.
    UNKNOWN,
    SIGNED_IN,
    NOT_SIGNED_IN,
}

const authStatus = ref(AuthStatus.UNKNOWN);

export function handleAuthenticated() {
    authStatus.value = AuthStatus.SIGNED_IN;

    // Avoid redirecting the user when the router is not ready yet, as the route
    // returned by router.currentRoute.value will be incorrect.
    if (!routerIsReady) {
        return;
    }

    // When on the login page and we are authenticated, redirect the user to the landing page.
    if (["login", "home"].includes(String(router.currentRoute.value.name))) {
        router.push("/");
    }
}

export function handleUnauthenticated() {
    authStatus.value = AuthStatus.NOT_SIGNED_IN;

    // Avoid redirecting the user when the router is not ready yet, as the route
    // returned by router.currentRoute.value will be incorrect.
    if (!routerIsReady) {
        return;
    }

    if (!["login", "home"].includes(String(router.currentRoute.value.name))) {
        router.push({ name: "home" });
    }
}

authentication.events.addEventListener("authenticated", handleAuthenticated);
authentication.events.addEventListener(
    "unauthenticated",
    handleUnauthenticated
);

export { getToken } from "@/lib/integrations/index";
export function useAuthenticationService() {
    return {
        authStatus,
        getToken: authentication.getToken,
        signOut: authentication.signOut,
    };
}
